import { Button } from "../ui";
import { useLabel } from "../lib/labels";
import { navigateExternal } from "../lib/postmessage";

interface LoginNudgeData {
  locale?: string;
  /** 회원가입(Join) 페이지 full URL. 서버가 ``build_nav_url`` 로 채운다. */
  joinUrl?: string;
  /** 로그인 페이지 full URL. 서버가 ``build_nav_url`` 로 채운다. */
  loginUrl?: string;
  title?: string;
  body?: string;
  labels?: Record<string, string>;
}

interface Props {
  data: LoginNudgeData;
  sessionToken: string;
}

/**
 * IS-04 로그인 유도 넛지.
 * 마크업 = guide ai-lists ``.ac-login-nudge`` (Sign in + Join us).
 * CTA 는 페이지 이동 — URL 은 서버 payload 를 그대로 ``navigateExternal`` 한다.
 */
export default function LoginNudgeCard({ data, sessionToken }: Props) {
  const title = useLabel("title", data.title || "Unlock Member Rewards");
  const body = data.body || useLabel(
    "body",
    "Sign up free for welcome offers, member-only deals and more",
  );
  const joinCta = useLabel("joinCta", "Join us");
  const signInCta = useLabel("signInCta", "Sign in");

  const go = (url: string | undefined, field: "joinUrl" | "loginUrl") => {
    if (!url) {
      console.warn(
        `[LoginNudgeCard] data.${field} 누락 — 서버가 build_nav_url 로 채워야 함`,
      );
      return;
    }
    navigateExternal(url, { target: "_top" }, { sessionId: sessionToken });
  };

  return (
    <section className="ac-login-nudge">
      <div className="ac-title-wrap">
        <strong className="ac-title nudge">
          <span className="ico" aria-hidden="true" />
          {title}
        </strong>
        <p className="ac-title-desc">{body}</p>
      </div>
      <div className="ac-btn-wrap">
        <Button
          variant="secondary"
          size="xs"
          onClick={() => go(data.loginUrl, "loginUrl")}
        >
          {signInCta}
        </Button>
        <Button
          variant="primary"
          size="xs"
          onClick={() => go(data.joinUrl, "joinUrl")}
        >
          {joinCta}
        </Button>
      </div>
    </section>
  );
}
